var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "settings-modal default-modal" }, [
    _c("div", { staticClass: "default-modal__header" }, [
      _c(
        "button",
        {
          staticClass: "default-modal__close settings-modal__close",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("closeAll")
            },
          },
        },
        [_c("IconComponent", { attrs: { name: "close" } })],
        1
      ),
      _c("h4", { staticClass: "default-modal__title" }, [
        _vm._v("Изменение персональных данных"),
      ]),
    ]),
    _c("div", { staticClass: "default-modal__body" }, [
      _c(
        "div",
        { staticClass: "settings-modal__inputs" },
        [
          _c("InputComponent", {
            attrs: { errors: _vm.form.name.errors, placeholder: "Имя" },
            model: {
              value: _vm.form.name.value,
              callback: function ($$v) {
                _vm.$set(_vm.form.name, "value", $$v)
              },
              expression: "form.name.value",
            },
          }),
          _c("InputComponent", {
            attrs: { errors: _vm.form.surname.errors, placeholder: "Фамилия" },
            model: {
              value: _vm.form.surname.value,
              callback: function ($$v) {
                _vm.$set(_vm.form.surname, "value", $$v)
              },
              expression: "form.surname.value",
            },
          }),
          _c("InputComponent", {
            attrs: {
              errors: _vm.form.birthday.errors,
              placeholder: "Дата рождения",
              mask: "##.##.####",
            },
            model: {
              value: _vm.form.birthday.value,
              callback: function ($$v) {
                _vm.$set(_vm.form.birthday, "value", $$v)
              },
              expression: "form.birthday.value",
            },
          }),
          _c("InputComponent", {
            attrs: {
              errors: _vm.form.phone.errors,
              placeholder: "Номер телефона",
              mask: "+7 (###) ###-##-##",
            },
            model: {
              value: _vm.form.phone.value,
              callback: function ($$v) {
                _vm.$set(_vm.form.phone, "value", $$v)
              },
              expression: "form.phone.value",
            },
          }),
          _c("InputComponent", {
            attrs: {
              errors: _vm.form.email.errors,
              placeholder: "Электронная почта",
              type: "email",
            },
            model: {
              value: _vm.form.email.value,
              callback: function ($$v) {
                _vm.$set(_vm.form.email, "value", $$v)
              },
              expression: "form.email.value",
            },
          }),
          _c("div", { staticClass: "settings-modal__footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--gray",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.logout.apply(null, arguments)
                  },
                },
              },
              [_c("span", [_vm._v("Выйти")])]
            ),
            _c(
              "button",
              {
                staticClass: "btn btn--black",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.submit.apply(null, arguments)
                  },
                },
              },
              [
                _vm.loading
                  ? _c("IconComponent", { attrs: { name: "loading" } })
                  : _c("span", [_vm._v("Изменить данные")]),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }